import * as React from 'react';
import { FC } from 'react';
import ShoppingCartIcon from '@material-ui/icons/ShoppingCart';

import CardWithIcon from './CardWithIcon';

interface Props {
    value?: string;
}

const NbNewOrders: FC<Props> = ({ value }) => {
    return (
        <CardWithIcon
            to="/commands"
            icon={ShoppingCartIcon}
            title={'Zamówienia w obecnym miesiącu'}
            subtitle={value}
        />
    );
};

export default NbNewOrders;
